import { css, keyframes } from 'styled-components';
import { color } from '../style/variables.js';

// Example:
// const ActionButton = styled.button`
//   ${ButtonShimmerStyle};
//   border-radius: 4px;
// `;
//
// Override CSS variables only when a button needs a different shimmer:
// --button-shine-duration: 3s;
// --button-shine-width: 16px;
// --button-shine-height: 72px;
// --button-shine-skew: -32deg;
// --button-shine-gap: 8px;
//
// Default values:
// - duration: 2s
// - width: 20px
// - height: 88px
// - skew: -40deg
// - gap: 10px
// - color: color.neutral['100_alpha_20']

const buttonShine = keyframes`
  from {
    left: var(--button-shine-start, -40px);
    transform: translateY(-50%) skewX(var(--button-shine-skew, -40deg));
  }

  to {
    left: var(--button-shine-end, calc(100% + 40px));
    transform: translateY(-50%) skewX(var(--button-shine-skew, -40deg));
  }
`;

const ButtonShimmerStyle = css`
  --button-shine-duration: 2s;
  --button-shine-width: 20px;
  --button-shine-height: 88px;
  --button-shine-skew: -40deg;
  --button-shine-gap: 10px;
  --button-shine-color: ${color.neutral['100_alpha_20']};

  position: relative;
  isolation: isolate;
  overflow: hidden;

  &::before,
  &::after {
    content: '';
    position: absolute;
    top: 50%;
    left: var(--button-shine-start, -40px);
    width: var(--button-shine-width);
    height: var(--button-shine-height);
    background: var(--button-shine-color);
    z-index: 0;
    pointer-events: none;
    transform: translateY(-50%) skewX(var(--button-shine-skew));
    will-change: left;
    animation: ${buttonShine} var(--button-shine-duration) linear infinite;
  }

  > * {
    position: relative;
    z-index: 1;
  }

  &::after {
    margin-left: var(--button-shine-gap);
  }

  &:disabled::before,
  &:disabled::after {
    animation: none;
    opacity: 0;
  }
`;

export default ButtonShimmerStyle;
